import GoogleAnalyticsVisitAdapter from './google-analytics-adapter/GoogleAnalyticsVisitAdapter';
import GoogleAnalyticsEventAdapter from './google-analytics-adapter/GoogleAnalyticsEventAdapter';
import ReactGA from 'react-ga4';

import Logger from '../functions/logging';

class GlobalAnalyticsAdapter {
	constructor() {
		this._googleAnalyticsVisitAdapter = new GoogleAnalyticsVisitAdapter();
		this._googleAnalyticsEventAdapter = new GoogleAnalyticsEventAdapter();
		//this._localAnalyticsAdapter       = new LocalAnalyticsAdapter();
		this.gAInitiated = false;
		this.GOOGLE_ANALYTICS_READY = 'GOOGLE_ANALYTICS_READY';
		this.className = 'GlobalAnalyticsAdapter';

		this.className = 'GoogleAnalyticsCore';
		this.ga = ReactGA.ga();
	}

	reportAnalyticsEvent(aevent) {

		aevent.isGoogleAnalyticsVisit ? this._googleAnalyticsVisitAdapter.reportAnalyticsEvent(aevent) : null;
		aevent.isGoogleAnalyticsEvent ? this._googleAnalyticsEventAdapter.reportAnalyticsEvent(aevent) : null;

	}

	initiateGoogleAnalytics(gaCode) {
		let self = this;

		if (gaCode.indexOf('UA') === -1) {
			throw (this.className + " ERROR: google analytics code provided is invalid ", gaCode);
		}

		Logger.log(self.className + ' : initiated GA succesfully [' + gaCode + ']');

		self.gAInitiated = true;
		// this.ga('create', gaCode, 'auto');
		// this.ga('send', 'pageview');
		ReactGA.send({ hitType: "pageview", page: "/my-path", title: "GlobalAnalyticsAdapter Title" });
	}

}

export default GlobalAnalyticsAdapter;


// WEBPACK FOOTER //
// ./src/analytics/GlobalAnalyticsAdapter.js